// removed by extract-text-webpack-plugin
module.exports = {"wrap":"general__wrap___1NFuW bg-white pinBL position-absolute width-100","footer":"general__footer___3Cwi7 borderRadiusBottom-m paddingLeftRight-s paddingTop-s textAlign-center width-100","border":"general__border___3qRFR pinTL position-absolute width-100"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/CardFooter/style/general.css
// module id = 130
// module chunks = 0 1